/* global G */
import find from 'lib/sequence/component/children/find'
import { asyncPipeSpread } from 'lib/util'
import { hide, show } from 'lib/sequence/component/state/hidden'
import { toggleActions } from 'app/registration/action/invite'

/**
 * Shows/hides the password field based on the invitee's role.
 *
 * @param {Gaia.AppModule.Spec} module  the current module object composition
 * @returns {function(*, ...[*]): Promise<*[]>}
 */
const displayPassword = module => async (components, ...args) => {
  const { tabs, password } = components
  const { role } = tabs[G.STATE]

  role !== 'customer' && role !== 'requester'
    ? show(password)
    : hide(password)

  return [components, ...args]
}

/**
 * Registration Invite Contact Action
 *
 * @param {Gaia.AppModule.Spec} module
 * @returns {function(*): function(...[*]): Promise<*>}
 */
export default module => component => async (...args) => asyncPipeSpread(
  displayPassword(module),
  toggleActions(module),
)(find(module[G.STATE][G.ACTION][G.COMPONENT]), ...args)
